import React from "react"
import * as S from "../elements"
import { GridColumnProps, GridRowProps } from "styled-system"
import {
  StyledTextarea,
  InputWrapper,
  CheckMark,
  Error,
} from "../Input/elements"
import { FeedbackType } from "../"
import { Box } from "@components/Layout"

interface Props
  extends GridColumnProps,
    GridRowProps,
    React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  sublabel?: string
  feedbackType?: FeedbackType
  errorMsg?: string
}

export const Textarea: React.FC<Props> = ({
  label,
  sublabel,
  feedbackType,
  errorMsg,
  gridColumn,
  gridRow,
  ...rest
}) => {
  return (
    <>
      <Box width="100%">
        <S.Wrapper>
          <InputWrapper>
            <StyledTextarea
              hasError={typeof errorMsg !== "undefined"}
              {...rest}
            />
            {feedbackType === "success" && <CheckMark />}
            {feedbackType === "error" && <Error />}
          </InputWrapper>
        </S.Wrapper>
        {errorMsg && <S.Error>{errorMsg}</S.Error>}
      </Box>
    </>
  )
}
